import { journeysSearch, type JourneysSearch } from './journeysSearch.ts';

/**
 * A journey's URL: the list's filters, carried along for the way back, and
 * `plan`, the step whose planning dialog opens straight away. That is where a
 * reminder's "Plan dit gesprek" lands.
 */
export interface JourneyDetailSearch extends JourneysSearch {
  plan?: string;
}

export function journeyDetailSearch(
  search: Record<string, unknown>,
): JourneyDetailSearch {
  const plan =
    typeof search.plan === 'string' && search.plan !== '' ? search.plan : undefined;
  return { ...journeysSearch(search), plan };
}
